import { Outlet, createFileRoute, redirect } from '@tanstack/react-router';
import { supabase } from '@/lib/supabase';
import { CommandPalette } from '@/components/command-palette';
import { AIRail } from '@/components/ai-rail';
import { SmsLiveToast } from '@/components/comms/sms-live-toast';
import { FollowUpToast } from '@/components/follow-ups/follow-up-toast';
import { useGlobalKeys } from '@/hooks/use-global-keys';
import { useUserPreferences } from '@/features/preferences/queries';
import { useTheme } from '@/components/theme-provider';
import { useEffect } from 'react';

export const Route = createFileRoute('/_auth')({
  beforeLoad: async ({ location }) => {
    const { data } = await supabase.auth.getSession();
    if (!data.session) {
      throw redirect({ to: '/login', search: { redirect: location.href } });
    }
  },
  component: AuthLayout,
});

function AuthLayout(): JSX.Element {
  const { setTheme } = useTheme();
  const { data: prefs } = useUserPreferences();

  // Hydrate theme from server prefs once on first auth load
  useEffect(() => {
    if (prefs?.theme) setTheme(prefs.theme);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [prefs?.theme]);

  useGlobalKeys();

  return (
    <div className="flex h-screen min-h-0">
      <div className="flex-1 min-w-0">
        <Outlet />
      </div>
      <AIRail />
      <CommandPalette />
      <SmsLiveToast />
      <FollowUpToast />
    </div>
  );
}
